import { remark } from 'remark';
export default (markdown) => {
    const arr = markdown.split('\n\n');
    const lines = ['', '', '', ''];
    for (const [i, ast] of arr.map(md => remark().parse(md)).entries()) {
        lines[i] = transformToMinecraftJSON(ast);
    }
    return lines;
};
function transformToMinecraftJSON(element) {
    switch (element.type) {
        case 'root': {
            if (!element.children)
                return;
            return element.children.map(child => transformToMinecraftJSON(child)).filter(Boolean);
        }
        case 'paragraph': {
            if (!element.children)
                return;
            const transformedChildren = element.children.map(child => transformToMinecraftJSON(child)).filter(Boolean);
            return transformedChildren.flat();
        }
        case 'strong': {
            if (!element.children)
                return;
            return [{ bold: true, text: element.children[0].value }];
        }
        case 'text': {
            return { text: element.value };
        }
        case 'emphasis': {
            if (!element.children)
                return;
            return [{ italic: true, text: element.children[0].value }];
        }
        default:
            // todo leave untouched eg links
            return element.value;
    }
}
